/**
 * @fileoverview gRPC-Web generated client stub for model
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: model/policy.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var common_collections_pb = require('../common/collections_pb.js')

var common_grc_platform_pb = require('../common/grc_platform_pb.js')

var common_model_pb = require('../common/model_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var model_framework_pb = require('../model/framework_pb.js')

var model_filters_pb = require('../model/filters_pb.js')

var audit_audit_pb = require('../audit/audit_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.model = require('./policy_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.model.PolicyClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.model.PolicyPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.CreateOrUpdatePolicyRequest,
 *   !proto.model.PolicyRecord>}
 */
const methodDescriptor_Policy_CreateOrUpdate = new grpc.web.MethodDescriptor(
  '/model.Policy/CreateOrUpdate',
  grpc.web.MethodType.UNARY,
  proto.model.CreateOrUpdatePolicyRequest,
  proto.model.PolicyRecord,
  /**
   * @param {!proto.model.CreateOrUpdatePolicyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyRecord.deserializeBinary
);


/**
 * @param {!proto.model.CreateOrUpdatePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.createOrUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/CreateOrUpdate',
      request,
      metadata || {},
      methodDescriptor_Policy_CreateOrUpdate,
      callback);
};


/**
 * @param {!proto.model.CreateOrUpdatePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.createOrUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/CreateOrUpdate',
      request,
      metadata || {},
      methodDescriptor_Policy_CreateOrUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetPolicyRequest,
 *   !proto.model.PolicyRecord>}
 */
const methodDescriptor_Policy_Get = new grpc.web.MethodDescriptor(
  '/model.Policy/Get',
  grpc.web.MethodType.UNARY,
  proto.model.GetPolicyRequest,
  proto.model.PolicyRecord,
  /**
   * @param {!proto.model.GetPolicyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyRecord.deserializeBinary
);


/**
 * @param {!proto.model.GetPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/Get',
      request,
      metadata || {},
      methodDescriptor_Policy_Get,
      callback);
};


/**
 * @param {!proto.model.GetPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/Get',
      request,
      metadata || {},
      methodDescriptor_Policy_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetPolicyFrameworksRequest,
 *   !proto.model.Frameworks>}
 */
const methodDescriptor_Policy_GetFrameworks = new grpc.web.MethodDescriptor(
  '/model.Policy/GetFrameworks',
  grpc.web.MethodType.UNARY,
  proto.model.GetPolicyFrameworksRequest,
  model_framework_pb.Frameworks,
  /**
   * @param {!proto.model.GetPolicyFrameworksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  model_framework_pb.Frameworks.deserializeBinary
);


/**
 * @param {!proto.model.GetPolicyFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.Frameworks)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.Frameworks>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.getFrameworks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/GetFrameworks',
      request,
      metadata || {},
      methodDescriptor_Policy_GetFrameworks,
      callback);
};


/**
 * @param {!proto.model.GetPolicyFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.Frameworks>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.getFrameworks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/GetFrameworks',
      request,
      metadata || {},
      methodDescriptor_Policy_GetFrameworks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ListPoliciesRequest,
 *   !proto.common.StringList>}
 */
const methodDescriptor_Policy_Find = new grpc.web.MethodDescriptor(
  '/model.Policy/Find',
  grpc.web.MethodType.UNARY,
  proto.model.ListPoliciesRequest,
  common_collections_pb.StringList,
  /**
   * @param {!proto.model.ListPoliciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_collections_pb.StringList.deserializeBinary
);


/**
 * @param {!proto.model.ListPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.common.StringList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.common.StringList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.find =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/Find',
      request,
      metadata || {},
      methodDescriptor_Policy_Find,
      callback);
};


/**
 * @param {!proto.model.ListPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.common.StringList>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.find =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/Find',
      request,
      metadata || {},
      methodDescriptor_Policy_Find);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ListPoliciesRequest,
 *   !proto.common.StringList>}
 */
const methodDescriptor_Policy_ListIds = new grpc.web.MethodDescriptor(
  '/model.Policy/ListIds',
  grpc.web.MethodType.UNARY,
  proto.model.ListPoliciesRequest,
  common_collections_pb.StringList,
  /**
   * @param {!proto.model.ListPoliciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_collections_pb.StringList.deserializeBinary
);


/**
 * @param {!proto.model.ListPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.common.StringList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.common.StringList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.listIds =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/ListIds',
      request,
      metadata || {},
      methodDescriptor_Policy_ListIds,
      callback);
};


/**
 * @param {!proto.model.ListPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.common.StringList>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.listIds =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/ListIds',
      request,
      metadata || {},
      methodDescriptor_Policy_ListIds);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ListPoliciesRequest,
 *   !proto.model.PolicyRecords>}
 */
const methodDescriptor_Policy_List = new grpc.web.MethodDescriptor(
  '/model.Policy/List',
  grpc.web.MethodType.UNARY,
  proto.model.ListPoliciesRequest,
  proto.model.PolicyRecords,
  /**
   * @param {!proto.model.ListPoliciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyRecords.deserializeBinary
);


/**
 * @param {!proto.model.ListPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyRecords)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyRecords>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/List',
      request,
      metadata || {},
      methodDescriptor_Policy_List,
      callback);
};


/**
 * @param {!proto.model.ListPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyRecords>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/List',
      request,
      metadata || {},
      methodDescriptor_Policy_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_Reset = new grpc.web.MethodDescriptor(
  '/model.Policy/Reset',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.reset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/Reset',
      request,
      metadata || {},
      methodDescriptor_Policy_Reset,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.reset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/Reset',
      request,
      metadata || {},
      methodDescriptor_Policy_Reset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.AddPolicyDocumentRequest,
 *   !proto.model.PolicyDocRecord>}
 */
const methodDescriptor_Policy_AddPolicyDocument = new grpc.web.MethodDescriptor(
  '/model.Policy/AddPolicyDocument',
  grpc.web.MethodType.UNARY,
  proto.model.AddPolicyDocumentRequest,
  proto.model.PolicyDocRecord,
  /**
   * @param {!proto.model.AddPolicyDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyDocRecord.deserializeBinary
);


/**
 * @param {!proto.model.AddPolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyDocRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyDocRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.addPolicyDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/AddPolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_AddPolicyDocument,
      callback);
};


/**
 * @param {!proto.model.AddPolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyDocRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.addPolicyDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/AddPolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_AddPolicyDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ReplacePolicyDocumentRequest,
 *   !proto.model.PolicyDocRecord>}
 */
const methodDescriptor_Policy_ReplacePolicyDocument = new grpc.web.MethodDescriptor(
  '/model.Policy/ReplacePolicyDocument',
  grpc.web.MethodType.UNARY,
  proto.model.ReplacePolicyDocumentRequest,
  proto.model.PolicyDocRecord,
  /**
   * @param {!proto.model.ReplacePolicyDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyDocRecord.deserializeBinary
);


/**
 * @param {!proto.model.ReplacePolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyDocRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyDocRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.replacePolicyDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/ReplacePolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_ReplacePolicyDocument,
      callback);
};


/**
 * @param {!proto.model.ReplacePolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyDocRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.replacePolicyDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/ReplacePolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_ReplacePolicyDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.DeletePolicyDocumentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_DeletePolicyDocument = new grpc.web.MethodDescriptor(
  '/model.Policy/DeletePolicyDocument',
  grpc.web.MethodType.UNARY,
  proto.model.DeletePolicyDocumentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.DeletePolicyDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.DeletePolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.deletePolicyDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/DeletePolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_DeletePolicyDocument,
      callback);
};


/**
 * @param {!proto.model.DeletePolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.deletePolicyDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/DeletePolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_DeletePolicyDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdatePolicyDocumentCaptionRequest,
 *   !proto.model.PolicyDocRecord>}
 */
const methodDescriptor_Policy_UpdatePolicyDocumentCaption = new grpc.web.MethodDescriptor(
  '/model.Policy/UpdatePolicyDocumentCaption',
  grpc.web.MethodType.UNARY,
  proto.model.UpdatePolicyDocumentCaptionRequest,
  proto.model.PolicyDocRecord,
  /**
   * @param {!proto.model.UpdatePolicyDocumentCaptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyDocRecord.deserializeBinary
);


/**
 * @param {!proto.model.UpdatePolicyDocumentCaptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyDocRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyDocRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.updatePolicyDocumentCaption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/UpdatePolicyDocumentCaption',
      request,
      metadata || {},
      methodDescriptor_Policy_UpdatePolicyDocumentCaption,
      callback);
};


/**
 * @param {!proto.model.UpdatePolicyDocumentCaptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyDocRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.updatePolicyDocumentCaption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/UpdatePolicyDocumentCaption',
      request,
      metadata || {},
      methodDescriptor_Policy_UpdatePolicyDocumentCaption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.ListPolicyDocumentsRequest,
 *   !proto.model.PolicyDocRecords>}
 */
const methodDescriptor_Policy_ListPolicyDocuments = new grpc.web.MethodDescriptor(
  '/model.Policy/ListPolicyDocuments',
  grpc.web.MethodType.UNARY,
  proto.model.ListPolicyDocumentsRequest,
  proto.model.PolicyDocRecords,
  /**
   * @param {!proto.model.ListPolicyDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyDocRecords.deserializeBinary
);


/**
 * @param {!proto.model.ListPolicyDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyDocRecords)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyDocRecords>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.listPolicyDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/ListPolicyDocuments',
      request,
      metadata || {},
      methodDescriptor_Policy_ListPolicyDocuments,
      callback);
};


/**
 * @param {!proto.model.ListPolicyDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyDocRecords>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.listPolicyDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/ListPolicyDocuments',
      request,
      metadata || {},
      methodDescriptor_Policy_ListPolicyDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetPolicyDocumentRequest,
 *   !proto.model.PolicyDocRecord>}
 */
const methodDescriptor_Policy_GetPolicyDocument = new grpc.web.MethodDescriptor(
  '/model.Policy/GetPolicyDocument',
  grpc.web.MethodType.UNARY,
  proto.model.GetPolicyDocumentRequest,
  proto.model.PolicyDocRecord,
  /**
   * @param {!proto.model.GetPolicyDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyDocRecord.deserializeBinary
);


/**
 * @param {!proto.model.GetPolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyDocRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyDocRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.getPolicyDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/GetPolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_GetPolicyDocument,
      callback);
};


/**
 * @param {!proto.model.GetPolicyDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyDocRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.getPolicyDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/GetPolicyDocument',
      request,
      metadata || {},
      methodDescriptor_Policy_GetPolicyDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetPolicyAcknowledgementFormRequest,
 *   !proto.model.GetPolicyAcknowledgementFormResponse>}
 */
const methodDescriptor_Policy_GetPolicyAcknowledgementForm = new grpc.web.MethodDescriptor(
  '/model.Policy/GetPolicyAcknowledgementForm',
  grpc.web.MethodType.UNARY,
  proto.model.GetPolicyAcknowledgementFormRequest,
  proto.model.GetPolicyAcknowledgementFormResponse,
  /**
   * @param {!proto.model.GetPolicyAcknowledgementFormRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.GetPolicyAcknowledgementFormResponse.deserializeBinary
);


/**
 * @param {!proto.model.GetPolicyAcknowledgementFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.GetPolicyAcknowledgementFormResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.GetPolicyAcknowledgementFormResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.getPolicyAcknowledgementForm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/GetPolicyAcknowledgementForm',
      request,
      metadata || {},
      methodDescriptor_Policy_GetPolicyAcknowledgementForm,
      callback);
};


/**
 * @param {!proto.model.GetPolicyAcknowledgementFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.GetPolicyAcknowledgementFormResponse>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.getPolicyAcknowledgementForm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/GetPolicyAcknowledgementForm',
      request,
      metadata || {},
      methodDescriptor_Policy_GetPolicyAcknowledgementForm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetPolicyControlsRequest,
 *   !proto.common.StringList>}
 */
const methodDescriptor_Policy_GetControls = new grpc.web.MethodDescriptor(
  '/model.Policy/GetControls',
  grpc.web.MethodType.UNARY,
  proto.model.GetPolicyControlsRequest,
  common_collections_pb.StringList,
  /**
   * @param {!proto.model.GetPolicyControlsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_collections_pb.StringList.deserializeBinary
);


/**
 * @param {!proto.model.GetPolicyControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.common.StringList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.common.StringList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.getControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/GetControls',
      request,
      metadata || {},
      methodDescriptor_Policy_GetControls,
      callback);
};


/**
 * @param {!proto.model.GetPolicyControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.common.StringList>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.getControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/GetControls',
      request,
      metadata || {},
      methodDescriptor_Policy_GetControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.common.StringList,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_AddControls = new grpc.web.MethodDescriptor(
  '/model.Policy/AddControls',
  grpc.web.MethodType.UNARY,
  common_collections_pb.StringList,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.common.StringList} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.common.StringList} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.addControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/AddControls',
      request,
      metadata || {},
      methodDescriptor_Policy_AddControls,
      callback);
};


/**
 * @param {!proto.common.StringList} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.addControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/AddControls',
      request,
      metadata || {},
      methodDescriptor_Policy_AddControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.DismissRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_Dismiss = new grpc.web.MethodDescriptor(
  '/model.Policy/Dismiss',
  grpc.web.MethodType.UNARY,
  proto.model.DismissRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.DismissRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.DismissRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.dismiss =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/Dismiss',
      request,
      metadata || {},
      methodDescriptor_Policy_Dismiss,
      callback);
};


/**
 * @param {!proto.model.DismissRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.dismiss =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/Dismiss',
      request,
      metadata || {},
      methodDescriptor_Policy_Dismiss);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.common.StringList,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_RemoveControls = new grpc.web.MethodDescriptor(
  '/model.Policy/RemoveControls',
  grpc.web.MethodType.UNARY,
  common_collections_pb.StringList,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.common.StringList} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.common.StringList} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.removeControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/RemoveControls',
      request,
      metadata || {},
      methodDescriptor_Policy_RemoveControls,
      callback);
};


/**
 * @param {!proto.common.StringList} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.removeControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/RemoveControls',
      request,
      metadata || {},
      methodDescriptor_Policy_RemoveControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.GetPolicyAuditsRequest,
 *   !proto.model.GetPolicyAuditsResponse>}
 */
const methodDescriptor_Policy_GetPolicyAudits = new grpc.web.MethodDescriptor(
  '/model.Policy/GetPolicyAudits',
  grpc.web.MethodType.UNARY,
  proto.model.GetPolicyAuditsRequest,
  proto.model.GetPolicyAuditsResponse,
  /**
   * @param {!proto.model.GetPolicyAuditsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.GetPolicyAuditsResponse.deserializeBinary
);


/**
 * @param {!proto.model.GetPolicyAuditsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.GetPolicyAuditsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.GetPolicyAuditsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.getPolicyAudits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/GetPolicyAudits',
      request,
      metadata || {},
      methodDescriptor_Policy_GetPolicyAudits,
      callback);
};


/**
 * @param {!proto.model.GetPolicyAuditsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.GetPolicyAuditsResponse>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.getPolicyAudits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/GetPolicyAudits',
      request,
      metadata || {},
      methodDescriptor_Policy_GetPolicyAudits);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.common.StringList,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_DisassociateControlFromPolicy = new grpc.web.MethodDescriptor(
  '/model.Policy/DisassociateControlFromPolicy',
  grpc.web.MethodType.UNARY,
  common_collections_pb.StringList,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.common.StringList} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.common.StringList} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.disassociateControlFromPolicy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/DisassociateControlFromPolicy',
      request,
      metadata || {},
      methodDescriptor_Policy_DisassociateControlFromPolicy,
      callback);
};


/**
 * @param {!proto.common.StringList} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.disassociateControlFromPolicy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/DisassociateControlFromPolicy',
      request,
      metadata || {},
      methodDescriptor_Policy_DisassociateControlFromPolicy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdatePolicyReadOnlyFieldsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_UpdatePolicyReadOnlyFields = new grpc.web.MethodDescriptor(
  '/model.Policy/UpdatePolicyReadOnlyFields',
  grpc.web.MethodType.UNARY,
  proto.model.UpdatePolicyReadOnlyFieldsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.UpdatePolicyReadOnlyFieldsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.UpdatePolicyReadOnlyFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.updatePolicyReadOnlyFields =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/UpdatePolicyReadOnlyFields',
      request,
      metadata || {},
      methodDescriptor_Policy_UpdatePolicyReadOnlyFields,
      callback);
};


/**
 * @param {!proto.model.UpdatePolicyReadOnlyFieldsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.updatePolicyReadOnlyFields =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/UpdatePolicyReadOnlyFields',
      request,
      metadata || {},
      methodDescriptor_Policy_UpdatePolicyReadOnlyFields);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.UpdatePolicyLabelsRequest,
 *   !proto.model.PolicyRecord>}
 */
const methodDescriptor_Policy_UpdatePolicyLabels = new grpc.web.MethodDescriptor(
  '/model.Policy/UpdatePolicyLabels',
  grpc.web.MethodType.UNARY,
  proto.model.UpdatePolicyLabelsRequest,
  proto.model.PolicyRecord,
  /**
   * @param {!proto.model.UpdatePolicyLabelsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyRecord.deserializeBinary
);


/**
 * @param {!proto.model.UpdatePolicyLabelsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.updatePolicyLabels =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/UpdatePolicyLabels',
      request,
      metadata || {},
      methodDescriptor_Policy_UpdatePolicyLabels,
      callback);
};


/**
 * @param {!proto.model.UpdatePolicyLabelsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.updatePolicyLabels =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/UpdatePolicyLabels',
      request,
      metadata || {},
      methodDescriptor_Policy_UpdatePolicyLabels);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.AddPolicyLabelRequest,
 *   !proto.model.PolicyRecord>}
 */
const methodDescriptor_Policy_AddPolicyLabel = new grpc.web.MethodDescriptor(
  '/model.Policy/AddPolicyLabel',
  grpc.web.MethodType.UNARY,
  proto.model.AddPolicyLabelRequest,
  proto.model.PolicyRecord,
  /**
   * @param {!proto.model.AddPolicyLabelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyRecord.deserializeBinary
);


/**
 * @param {!proto.model.AddPolicyLabelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.addPolicyLabel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/AddPolicyLabel',
      request,
      metadata || {},
      methodDescriptor_Policy_AddPolicyLabel,
      callback);
};


/**
 * @param {!proto.model.AddPolicyLabelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.addPolicyLabel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/AddPolicyLabel',
      request,
      metadata || {},
      methodDescriptor_Policy_AddPolicyLabel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.RemovePolicyLabelRequest,
 *   !proto.model.PolicyRecord>}
 */
const methodDescriptor_Policy_RemovePolicyLabel = new grpc.web.MethodDescriptor(
  '/model.Policy/RemovePolicyLabel',
  grpc.web.MethodType.UNARY,
  proto.model.RemovePolicyLabelRequest,
  proto.model.PolicyRecord,
  /**
   * @param {!proto.model.RemovePolicyLabelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.PolicyRecord.deserializeBinary
);


/**
 * @param {!proto.model.RemovePolicyLabelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.PolicyRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.PolicyRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.removePolicyLabel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/RemovePolicyLabel',
      request,
      metadata || {},
      methodDescriptor_Policy_RemovePolicyLabel,
      callback);
};


/**
 * @param {!proto.model.RemovePolicyLabelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.PolicyRecord>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.removePolicyLabel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/RemovePolicyLabel',
      request,
      metadata || {},
      methodDescriptor_Policy_RemovePolicyLabel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.SetPolicyAssigneesRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Policy_SetAssignees = new grpc.web.MethodDescriptor(
  '/model.Policy/SetAssignees',
  grpc.web.MethodType.UNARY,
  proto.model.SetPolicyAssigneesRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.model.SetPolicyAssigneesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.model.SetPolicyAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyClient.prototype.setAssignees =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.Policy/SetAssignees',
      request,
      metadata || {},
      methodDescriptor_Policy_SetAssignees,
      callback);
};


/**
 * @param {!proto.model.SetPolicyAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.model.PolicyPromiseClient.prototype.setAssignees =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.Policy/SetAssignees',
      request,
      metadata || {},
      methodDescriptor_Policy_SetAssignees);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.model.PolicyInternalServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.model.PolicyInternalServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.CreateOrUpdatePoliciesInternalRequest,
 *   !proto.model.CreateOrUpdatePoliciesInternalResponse>}
 */
const methodDescriptor_PolicyInternalService_CreateOrUpdatePolicies = new grpc.web.MethodDescriptor(
  '/model.PolicyInternalService/CreateOrUpdatePolicies',
  grpc.web.MethodType.UNARY,
  proto.model.CreateOrUpdatePoliciesInternalRequest,
  proto.model.CreateOrUpdatePoliciesInternalResponse,
  /**
   * @param {!proto.model.CreateOrUpdatePoliciesInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.CreateOrUpdatePoliciesInternalResponse.deserializeBinary
);


/**
 * @param {!proto.model.CreateOrUpdatePoliciesInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.CreateOrUpdatePoliciesInternalResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.CreateOrUpdatePoliciesInternalResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyInternalServiceClient.prototype.createOrUpdatePolicies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.PolicyInternalService/CreateOrUpdatePolicies',
      request,
      metadata || {},
      methodDescriptor_PolicyInternalService_CreateOrUpdatePolicies,
      callback);
};


/**
 * @param {!proto.model.CreateOrUpdatePoliciesInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.CreateOrUpdatePoliciesInternalResponse>}
 *     Promise that resolves to the response
 */
proto.model.PolicyInternalServicePromiseClient.prototype.createOrUpdatePolicies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.PolicyInternalService/CreateOrUpdatePolicies',
      request,
      metadata || {},
      methodDescriptor_PolicyInternalService_CreateOrUpdatePolicies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.model.AttachPolicyDocumentInternalRequest,
 *   !proto.model.AttachPolicyDocumentInternalResponse>}
 */
const methodDescriptor_PolicyInternalService_AttachPolicyDocument = new grpc.web.MethodDescriptor(
  '/model.PolicyInternalService/AttachPolicyDocument',
  grpc.web.MethodType.UNARY,
  proto.model.AttachPolicyDocumentInternalRequest,
  proto.model.AttachPolicyDocumentInternalResponse,
  /**
   * @param {!proto.model.AttachPolicyDocumentInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.model.AttachPolicyDocumentInternalResponse.deserializeBinary
);


/**
 * @param {!proto.model.AttachPolicyDocumentInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.model.AttachPolicyDocumentInternalResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.model.AttachPolicyDocumentInternalResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.model.PolicyInternalServiceClient.prototype.attachPolicyDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/model.PolicyInternalService/AttachPolicyDocument',
      request,
      metadata || {},
      methodDescriptor_PolicyInternalService_AttachPolicyDocument,
      callback);
};


/**
 * @param {!proto.model.AttachPolicyDocumentInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.model.AttachPolicyDocumentInternalResponse>}
 *     Promise that resolves to the response
 */
proto.model.PolicyInternalServicePromiseClient.prototype.attachPolicyDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/model.PolicyInternalService/AttachPolicyDocument',
      request,
      metadata || {},
      methodDescriptor_PolicyInternalService_AttachPolicyDocument);
};


module.exports = proto.model;

